export default __webpack_public_path__ + "static/test_1_2_ru-82e3fb449d7d1c470caab6595cfbf138.png";